import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getRegionByUser, getRoleByUser } from "../services/landing.service";

const initialState = {
  roleData: null,
  regionData: null,
  isRoleLoading: false,
  isRegionLoading: false,
  roleError: null,
  regionError: null,
  hasVisitedHome: false,
};

export const fetchRoles = createAsyncThunk(
  "landing/fetchRoles",
  async (request, { rejectWithValue }) => {
    try {
      const apiResponse = await getRoleByUser({ request });
      const data = await apiResponse.data.data;
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const fetchRegions = createAsyncThunk(
  "landing/fetchRegions",
  async (request, { rejectWithValue }) => {
    try {
      const apiResponse = await getRegionByUser({ request });
      return apiResponse.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const landingPageSlice = createSlice({
  name: "landing",
  initialState,
  reducers: {
    setVisitedHome: (state) => {
      state.hasVisitedHome = true;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.isRoleLoading = true;
        state.roleError = null;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.isRoleLoading = false;
        state.roleData = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.isRoleLoading = false;
        state.roleError = action.payload;
      })
      .addCase(fetchRegions.pending, (state) => {
        state.isRegionLoading = true;
        state.regionError = null;
      })
      .addCase(fetchRegions.fulfilled, (state, action) => {
        state.isRegionLoading = false;
        state.regionData = action.payload;
      })
      .addCase(fetchRegions.rejected, (state, action) => {
        state.isRegionLoading = false;
        state.regionError = action.payload;
      });
  },
});

export const { setVisitedHome } = landingPageSlice.actions;

export default landingPageSlice.reducer;
